import { useEffect, useRef, useState } from "react";
import { collection, setDoc, doc, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { mockListings } from "../data/mockListings";

export default function SeedData() {
  const seededRef = useRef(false); // 🔐 evita duplicados

  const [status, setStatus] = useState("Cargando...");

  useEffect(() => {
    const seed = async () => {
      if (seededRef.current) return; // ya se ejecutó una vez
      seededRef.current = true;

      const existing = await getDocs(collection(db, "listings"));
      if (!existing.empty) {
        setStatus("❌ Ya existen datos, no se vuelve a seedear.");
        return;
      }

      for (const item of mockListings) {
        const docRef = doc(collection(db, "listings")); // ID aleatorio
        const shortDescription = item.description?.slice(0, 150) + "...";

        await setDoc(docRef, {
          ...item,
          id: docRef.id,
          shortDescription,
          createdAt: new Date(),
        });
      }

      setStatus("✅ Datos cargados con éxito");
    };

    seed();
  }, []);

  return (
    <div className="p-10 text-center">
      <h1>{status}</h1>
    </div>
  );
}
